/* eslint-disable no-mixed-spaces-and-tabs */
import axios from 'axios'

function initialState() {
  return {
    navToggle: false,
    isApplicationLoaded: false,
    loadingHasFinish: false,
    languages: [{
      name: 'English',
      local: 'en',
      img: 'https://cdn.vuetifyjs.com/images/flags/us.png',
    },
      // {
      //   name: '简体中文',
      //   local: 'zh',
      //   img: 'https://cdn.vuetifyjs.com/images/flags/cn.png',
      // },
    ],
    allMessages: [
      // {
      //   level: 'error',
      //   title: 'Fetching continuous stations',
      //   content: 'Fail loading..Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat..',
      //   nextStep: 'try again...Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. aaaaaaaaaaa',
      // }
    ],
    allMessagesMaxLength: 5,
    snackbar: {
      icon: '',
      text: '',
      color: '',
      timeout: null,
    },
    errorDialog: {
      header: '',
      title: '',
      data: [],
      show: false,
    },
    mapServiceConfigs: [],
    newMapServiceConfigs: [],
    defaultMapConfig: [{
      LayerName: 'topo',
      DisplayName: 'Topographic',
      ShowOnLoad: true,
      Ordinal: 1,
      MapServices: [{
        ServiceType: 'basemapLayer',
        ServiceConfig: '{"text": "Topographic"}',
      }],
    },
    {
      LayerName: 'station',
      DisplayName: 'Stations',
      ShowOnLoad: true,
      Ordinal: 2,
      MapServices: [],
    },
    {
      LayerName: 'sat',
      DisplayName: 'MR Satellite',
      ShowOnLoad: false,
      Ordinal: 3,
      MapServices: [{
        ServiceType: 'wms',
        ServiceConfig: '{"url": "http://services.sentinel-hub.com/v1/wms/da7a2165-bbe7-a5d4-5887-72110185bd54?","format": "image/png","layers": "TRUE_COLOR,DATE,OUTLINE","maxcc": "20","priority": "mostRecent"}',
      }],
    },
    {
      LayerName: 'sampleSat',
      DisplayName: 'Sample Satellite',
      ShowOnLoad: false,
      Ordinal: 4,
      MapServices: [{
        ServiceType: 'wms',
        ServiceConfig: '{"url": "http://services.sentinel-hub.com/v1/wms/da7a2165-bbe7-a5d4-5887-72110185bd54?","format": "image/png","layers": "TRUE_COLOR,DATE,OUTLINE","maxcc": "20","priority": "mostRecent"}',
      }],
    },
    ],
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    // Could use a loading setting here to show that this data is loading in the UI
    async refreshData({ dispatch }, {
      monitoringFeatures,
    }) {
      if (monitoringFeatures) {
        try {
          let a = dispatch('datasource/fetchDataSources', {}, { root: true })
          let b = dispatch('navigation/fetchSideMenu', {}, { root: true })
          let c = dispatch('monitoringfeature/fetchMonitoringFeaturesUI', {}, { root: true })
          await Promise.all([a, b, c])

          dispatch('setSnackbar', ({
            text: 'Monitoring locations have been refreshed.',
            color: 'success',
            icon: 'done',
          }))
        } catch (error) {
          dispatch('setSnackbar', ({
            text: 'Oops, the locations could not be refreshed. Please reload the page — let us know if it happens again!',
            color: 'error',
            icon: 'error',
          }))
        }
      }
    },
    navDrawerChanged({ commit }) {
      commit('changeNavDrawer')
    },
    updateApplicationLoaded({ commit }, isLoaded) {
      commit('changeAppLoaded', isLoaded)
    },
    loadingHasFinished({ commit }) {
      commit('loadingHasFinish')
    },
    addMessage({ commit }, options) {
      var data = {
        level: options.level,
        title: options.title,
        content: options.content,
        nextStep: options.nextStep,
      }
      commit('addMessage', data)
    },
    deleteAllMessage({ commit }) {
      commit('deleteAllMessage')
    },
    deleteMessage({ commit }, data) {
      commit('deleteMessage', data)
    },
    async getMapServiceConfig({ commit }, options) {
      let url = 'api/UserGroup/MapLayer/' + options
      try {
        await axios.get(url)
          .then(res => {
            commit('SET_MapServiceConfig', res.data)
          })
      } catch (e) {
        console.log('Could not get map config from \'' + url)
      }
    },
    async getNewMapServiceConfig({ commit }, options) {
      let url = 'api/UserGroup/MapLayer/' + options
      try {
        await axios.get(url)
          .then(res => {
            commit('SET_NewMapServiceConfig', res.data)
          })
      } catch (e) {
        console.log('Could not get map config from \'' + url)
      }
    },
    async addMapLayer({ commit }, options) {
      let url = 'api/MapConfig/AddMapLayer'
      await axios.post(url, options.data)
        .then((res) => {
          commit('addMapLayer', res.data)
          options.successCb()
        })
        .catch((error) => {
          options.failedCb(error)
        })
    },
    async updateMapLayer({ commit }, options) {
      let url = 'api/MapConfig/UpdateMapLayer'
      await axios.post(url, options.data)
        .then((res) => {
          commit('updateMapLayer', res.data)
          options.successCb()
        })
        .catch((error) => {
          options.failedCb(error)
        })

    },
    async deleteMapLayer({ commit }, options) {
      let url = 'api/MapConfig/DeleteMapLayer?id=' + options.data.Id
      await axios.post(url)
        .then(() => {
          commit('deleteMapLayer', options.data)
          options.successCb()
        })
        .catch((error) => {
          options.failedCb(error)
        })
    },

    async updateMapServices({ commit }, options) {
      let url = 'api/MapConfig/UpdateMapService'
      await axios.post(url, options.data)
        .then((res) => {
          commit('updateMapServices', res.data)
          options.successCb()
        })
        .catch((error) => {
          options.failedCb(error)
        })
    },

    async AddDefaultMapLayers({ commit }, options) {
      let url = 'api/MapConfig/AddDefaultMapLayers/' + options.data
      await axios.post(url)
        .then((res) => {
          commit('SET_NewMapServiceConfig', res.data)
          options.successCb()
        })
        .catch((error) => {
          options.failedCb(error)
        })
    },
    setSnackbar({ commit }, {
      icon,
      text,
      color,
      timeout,
    }) {
      commit('setSnackbar', {
        icon,
        text,
        color,
        timeout,
      })
    },
    setErrorDialog({ commit }, errordialog) {
      commit('setErrorDialog', errordialog)
    },
    closeErrorDialog({ commit }) {
      commit('setErrorDialog', {
        title: '',
        data: [],
        show: false,
      })
    },
  },
  mutations: {
    changeNavDrawer(state) {
      state.navToggle = !state.navToggle
    },
    changeAppLoaded(state, payload) {
      state.isApplicationLoaded = payload
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        // Snackbar messages are used for logout. Don't want them erased.
        if (key == 'snackbar') return

        state[key] = s[key]
      })
    },
    loadingHasFinish(state) {
      state.loadingHasFinish = true
    },
    setSnackbar(state, snackbar) {
      state.snackbar = snackbar
    },
    setErrorDialog(state, errordialog) {
      state.errorDialog = errordialog
    },
    addMessage(state, data) {
      var dc = state.allMessages
      dc.push(data)
      dc = dc.length > state.allMessagesMaxLength ? dc.slice(-state.allMessagesMaxLength) : dc
      state.allMessages = dc
    },
    deleteAllMessage(state) {
      var dc = state.allMessages
      dc = []
      state.allMessages = dc
    },
    deleteMessage(state, data) {
      var dc = state.allMessages
      dc.splice(data, 1)
      state.allMessages = dc
    },
    SET_MapServiceConfig: (state, data) => state.mapServiceConfigs = data,
    SET_NewMapServiceConfig: (state, data) => state.newMapServiceConfigs = data,
    addMapLayer(state, data) {
      var dc = state.newMapServiceConfigs
      dc.splice(data.Ordinal - 1, 0, data)
      var needToUpdate = dc.filter(x => x.Ordinal >= data.Ordinal)
      needToUpdate.forEach(x => x.Ordinal++)
      state.newMapServiceConfigs = dc
    },
    updateMapLayer(state, data) {
      var dc = state.newMapServiceConfigs
      var updateItem = dc.find(x => x.Id == data.Id)
      var changeItem = dc.find(x => x.Ordinal == data.Ordinal)
      var tempOrdinal = updateItem.Ordinal
      changeItem.Ordinal = tempOrdinal

      updateItem.LayerName = data.LayerName
      updateItem.DisplayName = data.DisplayName
      updateItem.ShowOnLoad = data.ShowOnLoad
      updateItem.Ordinal = data.Ordinal
      updateItem.RoleMapId = data.RoleMapId

      state.newMapServiceConfigs = dc
    },
    deleteMapLayer(state, data) {
      var dc = state.newMapServiceConfigs
      var i = dc.findIndex(x => x.Id === data.Id)
      dc.splice(i, 1)
      for (; i < dc.length; i++) {
        dc[i].Ordinal = i + 1
      }
      state.newMapServiceConfigs = dc
    },

    updateMapServices(state, data) {
      var dc = state.newMapServiceConfigs
      var matched = dc.find(x => x.Id == data.Id)
      matched.MapServices = data.MapServices
      state.newMapServiceConfigs = dc
    },
  },

  getters: {
    navDrawerChange: state => {
      return state.navToggle
    },
    isApplicationLoaded: state => state.isApplicationLoaded,
    loadingHasFinish: state => state.loadingHasFinish,
    languages: state => state.languages,
    allMessages: state => state.allMessages,
    snackbar: state => state.snackbar,
    errorDialog: state => state.errorDialog,
    mapServiceConfigs: s => s.mapServiceConfigs,
    newMapServiceConfigs: s => s.newMapServiceConfigs,
    defaultMapConfig: s => s.defaultMapConfig,
  },
}